import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { documentationActions } from '../../actions/constant';
import templateService from 'src/services/apiServices/document-management/template-service';

const {
  REQUEST_GET_SUBMISSION_DOCUMENT,
  SUCCESS_GET_SUBMISSION_DOCUMENT,
  FAILURE_GET_SUBMISSION_DOCUMENT,
  LOADING_GET_SUBMISSION_DOCUMENT,
} = documentationActions;

function* getSubmissionDocument(action: any): SagaReturnType<any> {
  try {
    yield put({ type: LOADING_GET_SUBMISSION_DOCUMENT });
    const response = yield call(templateService.getSubmissionDocument, action.payload);
    if (response?.status === 200) {
      yield put({ type: SUCCESS_GET_SUBMISSION_DOCUMENT, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_GET_SUBMISSION_DOCUMENT, payload: error });
  }
}

function* getSubmissionDocumentSaga() {
  yield takeEvery(REQUEST_GET_SUBMISSION_DOCUMENT, getSubmissionDocument);
}

export default getSubmissionDocumentSaga;
